@let fin = finParcours();

<h2 class="paragraph-large-semibold">Description du métier</h2>

@if (fin) {
  <markdown [data]="fin.description" />
}
